export default {
  methods: {
    getChart(title, chartData) {
      return {
        chart: {
          type: "line",
        },
        legend: {
          enabled: chartData.series.length != 1,
        },
        plotOptions: {
          series: {
            label: {
              connectorAllowed: false,
            },
          },
        },
        title: {
          text: title,
        },
        xAxis: {
          categories: chartData.xAxis,
        },
        yAxis: {
          title: {
            text: title,
          },
        },
        series: chartData.series,
        credits: {
          enabled: false,
        },
      };
    },
  },
};
